// import React,{useRef} from 'react'
// import {  useState } from "react";
// import { useMutation } from '@apollo/client';
// import { Form, Modal } from 'react-bootstrap';
// import Button from 'react-bootstrap/Button';
// import { Options } from '../Constants/Option';
// import { ADD_WALLPAPER } from '../GraphQL/Mutations';
// import { GET_WALLPAPERS } from '../GraphQL/Queries';


//  function AddWallpaper(props) {

//     const [image, setImage] = useState(null);
//     const[title,setTitle]= useState(null);
//     const[description,setDescription]=useState(null);
//     const[category,setCategory]=useState(null);
//     const [validated, setValidated] = useState(false);
    

//     const formRef = useRef(null);
//     // const [msg, setMsg] = useState('');
//     // const [show, setShow] = useState(false);
//     const [uploadRequest, { loading, error }] = useMutation(
//       ADD_WALLPAPER
//     );

//   //   const handleClose = () => setShow(false);
//   // const handleShow = () => setShow(true);
    
  
//   const uploadFile = async (e) => {
//     const form = e.currentTarget;
//     setValidated(true);
//     if (form.checkValidity() === false) {
//       e.preventDefault();
//       e.stopPropagation();
//       return;
//     }
  
//     try {
//       const res = await uploadRequest({
//         variables: { image, title, category, description },
//         refetchQueries: [{ query: GET_WALLPAPERS }],
//       });
//       if (res.data) {
//         alert("Wallpaper Added Successfully");
//         handleReset();
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setValidated(false);
//     }
//   };
  

//       const handleReset = () => {
//         formRef.current.reset();
//         setTitle(false);
//         setDescription(false);
//         setImage(false);
//         setCategory(false);
//       };

//       // const handleSubmit = (event) => {
//       //    const form = event.currentTarget;
//       //   if (form.checkValidity() === false) {
//       //     event.preventDefault();
//       //     event.stopPropagation();
//       //   }
    
//       //   setValidated(true);
//       // };
    



//   return (
//     <>
//       <Modal
//         show={props.show}
//         onHide={props.close}
//         backdrop="static"
//         keyboard={false}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Upload Wallpaper</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form noValidate validated={validated} ref={formRef}>
//             <Form.Group className="mb-3" controlId="validationCustom01">
//               <Form.Label>Title</Form.Label>
//               <Form.Control
//                 type="Text"
//                 onChange={(e) => setTitle(e.target.value)}
//                 placeholder="Enter Title"
//                 required
//               />
//               <Form.Control.Feedback type="invalid">
//                 Please Enter Title.
//               </Form.Control.Feedback>
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="validationCustom01">
//             <Form.Label>Category</Form.Label>
//             <Form.Control as="select" type="select" required  onChange={(e) => setCategory(e.target.value)}>
//               <option value="" >Please Select Category</option>
//               {Options.map((option) => {
//                 return (
//                   <option value={option} >
//                     {option}
//                   </option>
//                 );
//               })}
             
//             </Form.Control>
//             <Form.Control.Feedback type="invalid">
//                 Please Select Category.
//               </Form.Control.Feedback>
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="validationCustom02">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 onChange={(e) => setDescription(e.target.value)}
//                 rows={3}
//                 placeholder="Enter Description"
//                 required
//               />
//               <Form.Control.Feedback type="invalid">
//                 Please Enter Description.
//               </Form.Control.Feedback>
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="validationCustom03">
//               <Form.Label>Upload Wallpaper</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept='.png,.jpg,.jpeg'
//                 onChange={(e) => setImage(e.target.files[0])}
//                 required
//               />
//               <Form.Control.Feedback type="invalid">
//                 Please Upload Image.
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => {props.close(); handleReset();}}>
//             Close
//           </Button>
//           <Button type="submit" onClick={uploadFile}>
//             Upload
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default AddWallpaper;




import React from "react";
import { useState, useRef } from "react";
import { useMutation } from "@apollo/client";
import { Modal, Form, Input, Select, Button, message } from "antd";
import { Options } from "../Constants/Option";
import { ADD_WALLPAPER } from "../GraphQL/Mutations";
import { GET_WALLPAPERS } from "../GraphQL/Queries";

const { TextArea } = Input;

function AddWallpaper(props) {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const [uploadRequest] = useMutation(ADD_WALLPAPER);

  const handleReset = () => {
    setTitle("");
    setDescription("");
    setImage(null);
    setCategory("");
    formRef.current.resetFields();
  };

  const uploadFile = async (e) => {
    setValidated(true);
    setLoading(true);
    try {
      const res = await uploadRequest({
        variables: { image, title, category, description },
        refetchQueries: [{ query: GET_WALLPAPERS }],
      });
      if (res.data) {
        message.info("Wallpaper Uploaded Successfully!");
        handleReset();
        //props.close();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setValidated(false);
      setLoading(false);
    }
  };

  const formRef = useRef(null);
  return (
    <Modal
      visible={props.show}
      onCancel={() => {
        props.close();
        handleReset();
      }}
      maskClosable={false}
      footer={null}
      destroyOnClose={true}
    >
      <h2>Upload Wallpaper</h2>
      <Form ref={formRef} onFinish={uploadFile}>
        <Form.Item
          label="Title"
          name="title"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          rules={[{ required: true, message: "Please enter a title!" }]}
        >
          <Input
            placeholder="Enter Title"
            onChange={(e) => setTitle(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          label="Category"
          name="category"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          rules={[{ required: true, message: "Please select a category!" }]}
        >
          <Select
            placeholder="Please Select Category"
            value={category}
            onChange={(value) => setCategory(value)}
          >
            {Options.map((option) => (
              <Select.Option key={option} value={option}>{option}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          rules={[{ required: true, message: "Please enter a description!" }]}
        >
          <TextArea
            placeholder="Enter Description"
            rows={3}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          label="Wallpaper"
          name="Wallpaper"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          rules={[{ required: true, message: "Please Upload a Wallpaper!" }]}
        >
          <Input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={validated}
          >
            Finish
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddWallpaper;
